import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CopyIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CopyIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M14.8396 22H5.83655C4.8574 22 4.06104 21.2036 4.06104 20.2245V7.09979C4.06104 6.12064 4.8574 5.32427 5.83655 5.32427H14.8396C15.8188 5.32427 16.6151 6.12064 16.6151 7.09979V20.2245C16.6151 21.2036 15.8188 22 14.8396 22ZM5.83655 6.84191C5.69428 6.84191 5.57867 6.95751 5.57867 7.09979V20.2245C5.57867 20.3668 5.69428 20.4824 5.83655 20.4824H14.8396C14.9819 20.4824 15.0975 20.3668 15.0975 20.2245V7.09979C15.0975 6.95751 14.9819 6.84191 14.8396 6.84191H5.83655Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.1639 18.6757C17.745 18.6757 17.4051 18.3358 17.4051 17.9169C17.4051 17.498 17.745 17.1581 18.1639 17.1581C18.3062 17.1581 18.4218 17.0425 18.4218 16.9002V3.77551C18.4218 3.63324 18.3062 3.51764 18.1639 3.51764H9.16082C9.01855 3.51764 8.90295 3.63324 8.90295 3.77551C8.90295 4.19444 8.56306 4.53433 8.14413 4.53433C7.7252 4.53433 7.38531 4.19444 7.38531 3.77551C7.38531 2.79636 8.18167 2 9.16082 2H18.1639C19.143 2 19.9394 2.79636 19.9394 3.77551V16.9002C19.9394 17.8794 19.143 18.6757 18.1639 18.6757Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CopyIcon;
